import {Injectable} from '@angular/core';
import {environment} from "../../environments/environment";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Observable} from "rxjs";
import {Constat} from "../shared/interfaces/Constat";

@Injectable({
  providedIn: 'root'
})
export class ConstatService {
  private readonly apiUrl = environment.apiUrl;

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  constructor(private http: HttpClient) {
  }

  getAllConstats(): Observable<Constat> {
    const url = `${this.apiUrl}/pad/constats`;
    return this.http.get<Constat>(url, this.httpOptions);
  }

  getConstatById(id: string): Observable<any> {
    const url = `${this.apiUrl}/pad/constats/EDL/` + id;
    return this.http.get<any>(url, this.httpOptions);
  }

  synchronise(formData: FormData) {
    return this.http.post<any>(`${this.apiUrl}/pad/constats/synchro`, formData);
  }

  sendMail(formData: FormData, idConstat:string) {
    return this.http.post<any>(`${this.apiUrl}/pad/constats/EDL/`+idConstat+`/email`, formData);
  }
}
